import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const Email = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12701"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12701)">
          <rect
            x="-2"
            y="-2"
            width="120"
            height="115"
            rx="5.48342"
            fill="#ECF2FF"
          />
          <path
            d="M62.1219 79.4211C62.3155 84.0319 63.8342 88.489 66.4963 92.2586H48.1162C50.7758 88.488 52.2933 84.0313 52.4874 79.4211H62.1219Z"
            fill="#E3E3E3"
          />
          <path
            d="M94.2155 69.7932V76.212C94.2155 77.0631 93.8773 77.8794 93.2754 78.4813C92.6736 79.0832 91.8573 79.4213 91.0061 79.4213H23.6093C22.7581 79.4213 21.9418 79.0832 21.3399 78.4813C20.738 77.8794 20.3999 77.0631 20.3999 76.212V69.7932H94.2155Z"
            fill="white"
          />
          <path
            d="M94.2155 21.6525V69.7931H20.3999V21.6525C20.3999 20.8013 20.738 19.985 21.3399 19.3831C21.9418 18.7812 22.7581 18.4431 23.6093 18.4431H91.0061C91.8573 18.4431 92.6736 18.7812 93.2754 19.3831C93.8773 19.985 94.2155 20.8013 94.2155 21.6525Z"
            fill="#66E1FF"
          />
          <path
            d="M20.3999 21.6525V69.7931H34.4088L85.7588 18.4431H23.6093C22.7581 18.4431 21.9418 18.7812 21.3399 19.3831C20.738 19.985 20.3999 20.8013 20.3999 21.6525Z"
            fill="#C2F3FF"
          />
          <path
            d="M48.1226 92.2586C50.7821 88.488 52.2997 84.0313 52.4937 79.4211"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M66.493 92.2586C63.8334 88.488 62.3159 84.0313 62.1218 79.4211"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M42.8655 92.2587H71.7498"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20.3999 69.7932H94.2155"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.0061 18.4431H23.6093C22.7581 18.4431 21.9418 18.7812 21.3399 19.3831C20.738 19.985 20.3999 20.8013 20.3999 21.6525V76.2118C20.3999 77.063 20.738 77.8793 21.3399 78.4812C21.9418 79.083 22.7581 79.4212 23.6093 79.4212H91.0061C91.8573 79.4212 92.6736 79.083 93.2754 78.4812C93.8773 77.8793 94.2155 77.063 94.2155 76.2118V21.6525C94.2155 20.8013 93.8773 19.985 93.2754 19.3831C92.6736 18.7812 91.8573 18.4431 91.0061 18.4431Z"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M46.0072 38.2693V46.2612L40.1091 42.3242L46.0072 38.2693Z"
            fill="#66E1FF"
          />
          <path
            d="M74.0231 42.3242L68.125 46.2611V38.6013L74.0231 42.3242Z"
            fill="#66E1FF"
          />
          <path
            d="M74.0232 42.3242V57.8067C74.0232 58.3933 73.7902 58.9559 73.3754 59.3707C72.9606 59.7855 72.398 60.0185 71.8114 60.0185H42.3209C41.7343 60.0185 41.1717 59.7855 40.7569 59.3707C40.3422 58.9559 40.1091 58.3933 40.1091 57.8067V42.3242L46.0072 46.2612L51.5662 49.9623L51.9053 49.6968H62.227L62.5661 49.9623L68.1251 46.2612L74.0232 42.3242Z"
            fill="#C2F3FF"
          />
          <path
            d="M69.6855 26.1472V45.4787L62.678 50.0352L62.291 49.7323H51.8411L51.4541 50.0352L44.4465 45.4787V26.1472C44.4465 25.7008 44.6238 25.2727 44.9394 24.9571C45.2549 24.6414 45.6829 24.4641 46.1291 24.4641H68.0029C68.4492 24.4641 68.8772 24.6414 69.1927 24.9571C69.5083 25.2727 69.6855 25.7008 69.6855 26.1472Z"
            fill="white"
          />
          <path
            d="M65.4431 24.7964H45.9463C45.5485 24.7964 45.1671 24.9539 44.8858 25.2343C44.6045 25.5148 44.4465 25.8951 44.4465 26.2917V45.2367L45.1724 45.7182L66.0325 24.919C65.8465 24.8384 65.6459 24.7967 65.4431 24.7964Z"
            fill="white"
          />
          <path
            d="M69.6857 39.7404L74.0232 42.3241V57.8066C74.0232 58.3932 73.7902 58.9558 73.3754 59.3705C72.9606 59.7853 72.398 60.0184 71.8114 60.0184H42.3209C41.7343 60.0184 41.1717 59.7853 40.7569 59.3705C40.3422 58.9558 40.1091 58.3932 40.1091 57.8066V42.3241L44.2806 39.7404"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M44.5327 55.5948L51.9053 49.6967H62.227L69.5996 55.5948"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M74.0232 42.3242L65.176 48.2223"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40.1091 42.3242L48.9563 48.2223"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M69.6855 45.054V26.297C69.6855 25.899 69.5083 25.5173 69.1927 25.2359C68.8772 24.9545 68.4492 24.7964 68.0029 24.7964H46.1291C45.6829 24.7964 45.2549 24.9545 44.9394 25.2359C44.6238 25.5173 44.4465 25.899 44.4465 26.297V45.054"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.4307 30.5278H53.3797"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M53.3799 34.9515H63.7016"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.4307 39.3751H63.7014"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M50.4307 43.7987H63.7014"
            stroke="#191919"
            strokeWidth="1.02814"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
Email.displayName = 'Email';
